import { gql } from "@apollo/client";

const GET_INVOICE_DELIVERY_APPROVALS = gql`
  query getInvoiceDeliveryApprovals(
    $clientIdentifier: String!
    $invoiceId: String!
  ) {
    invoice(clientIdentifier: $clientIdentifier, invoiceId: $invoiceId) {
      id
      invoiceNumber
      recipientApprovals {
        id
        changedAt
        comments {
          items {
            id
            content
            createdAt
            createdByUser {
              id
              firstName
              lastName
            }
          }
        }
        invoiceId
        recipientEmailAddress
        sentAt
        sentBySkynetUserId
        status
      }
    }
  }
`;

export default GET_INVOICE_DELIVERY_APPROVALS;
